export const defaultColumns = [
  { label: 'Status', value: 'status', className: 'w-10' },
  { label: 'Tipo', value: 'role', className: 'w-10' },
  { label: 'Filial', value: 'branchName', className: 'w-10' },
  { label: 'Nome', value: 'fullName' },
  { label: 'Último consumo', value: 'lastConsumption', className: 'w-10' },
  { label: 'Ações', value: 'actions', className: 'w-10' },
];
